import React, {useEffect} from 'react';
import {
    Button,
    Card,
    CircularProgress,
    Container,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    Radio,
    RadioGroup,
    Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow
} from '@material-ui/core';
import styled from 'styled-components';
import Layout from '../Shared/Layout';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils  from '@date-io/date-fns';
import { format } from 'date-fns'
import { useState } from 'react';
import {useForm, usePage} from "@inertiajs/inertia-react";
import TextField from "@material-ui/core/TextField";
import {Trans} from "../utils/i18n";
import InputLabel from "@material-ui/core/InputLabel";
import MuiSelect from "@material-ui/core/Select";
import timezones from "timezones-list";
import MuiButton from "@material-ui/core/Button";

const Wrapper = styled(Card)`
  margin: 20px 0;
  padding: 20px;
`;

const H1 = styled.h1`
    display: inline-block;
    margin-right: 30px;
`;

const ReportTypes = styled.div`
  display: flex;
`;

const ReportType = styled.div`
  text-align: center;
  flex-grow: 1;
  padding: 20px;
  cursor: pointer;
  font-weight: bold;
  border: 1px solid ${({ theme }) => theme.primary};
  background-color: ${({ selected, theme }) => selected ? theme.primary : 'transparent'};
  color: ${({ selected, theme }) => selected ? theme.white : theme.primary};

  &:first-of-type {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }

  &:last-of-type {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
`;

const ReportLabel = styled.p`
  font-size: 15.7px;
  font-family: 'Roboto', sans-serif;
  color: rgba(0, 0, 0, 0.54);
`;


const ButtonWrapper = styled.div`
  margin-top: 30px;
`;

function ReportFormItem({ item }) {
    if(item.type === 'date') {
        return <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
                variant="inline"
                format="yyyy/MM/dd"
                margin="normal"
                id="date"
                label="Enter a return date (YYYY-MM-DD)"
                value={data.date}
                onChange={e => setData('date', e)}
            />
        </MuiPickersUtilsProvider>;
    }
    return <div></div>
}

export default function ReportForm({ report }) {
    const { props: { csrf_token } } = usePage();
    const [htmlTableData, setHtmlTableData] = useState(null);

    const initalValues = report.params.reduce((carry, item) => {
        carry[item.name] = null;
        return carry;
    }, {
        report: report.name
    });
    console.log(htmlTableData)

    const { data, setData, post, processing, errors } = useForm(initalValues);

    const handleSubmit = async e => {
        if(report.enable_html_table && data.format === 'html') {
            e.preventDefault();
            const htmlBody = { ...data };
            report.params.filter(item => item.type === 'date').forEach(item => {
                htmlBody[item.name] = format(htmlBody[item.name], item.formatFrontend);
            });
            axios.post(route('report.report'), {
                ...htmlBody
            })
                .then(response => {
                    setHtmlTableData(response.data);
                })
                .catch(error => {
                    console.log(error);
                });
            return;
        }

        //e.preventDefault();

        // post(route('report.report'), {
        //     onSuccess: (e) => console.log(e),
        //     onError: (e) => console.log(e),
        // });
    }

    const formValid = report.params.reduce((carry, item) => {
        return carry && data[item.name];
    }, data.format);

    return (
        <form onSubmit={handleSubmit} method={'POST'} action={route('report.report')}>
            <input type={'hidden'} value={report.name} name={'report'}/>
            <input type={'hidden'} value={csrf_token} name={'_token'}/>

            <Grid container spacing={3} alignItems="center">
            {
                report.params.map(item => <Grid item xs={12}>
                    {
                        item.type === 'date' &&
                        <>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    variant="inline"
                                    format={item.formatFrontend}
                                    margin="normal"
                                    id="date"
                                    label={`${item.label} (${item.format})`}
                                    value={data[item.name]}
                                    onChange={e => e instanceof Date && !isNaN(e) && setData(item.name, e) && console.log(e)}
                                    required={true}
                                />
                            </MuiPickersUtilsProvider>
                            <input type={'hidden'} value={data[item.name] && format(data[item.name], item.formatFrontend)} name={item.name} required={true}/>
                        </>
                    }
                    {
                        item.type === 'select' &&
                            <FormControl
                                error={errors[item.name]}
                                variant="outlined"
                            >
                                <InputLabel
                                    htmlFor={'select' + item.name}>
                                    { item.name }
                                </InputLabel>
                                <MuiSelect
                                    name={item.name}
                                    id={'select' + item.name }
                                    native
                                    label={item.label}
                                    onChange={e => setData(item.name, e.target.value)}
                                    required={true}
                                >
                                    <option aria-label={<Trans i18nKey="select.none">None</Trans>} value="" />
                                    {
                                        item.options
                                            .map((item, index) => (
                                                <option key={index} value={item}>{item}</option>
                                            ))
                                    }
                                </MuiSelect>
                            </FormControl>
                    }
                    {
                        item.type === 'text' &&
                            <TextField
                                id={item.name}
                                label={item.label}
                                name={item.name}
                                type={'text'}
                                helperText={errors[item.name]}
                                error={errors[item.name]}
                                variant="outlined"
                                onChange={e => setData(item.name, e.target.value)}
                                required={true}
                            />
                    }
                    {
                        item.type === 'textarea' &&
                            <TextField
                                id={item.name}
                                label={item.label}
                                name={item.name}
                                rows={5}
                                type={'text'}
                                multiline={true}
                                helperText={errors[item.name]}
                                error={errors[item.name]}
                                variant="outlined"
                                onChange={e => setData(item.name, e.target.value)}
                                required={true}
                            />
                    }
                </Grid>)
            }
            <Grid item xs={12}>
                <FormControl component="fieldset">
                    <FormLabel component="legend"><Trans i18nKey="report.format.label">Select a format</Trans></FormLabel>
                    <RadioGroup
                        aria-label="format"
                        name="format"
                        value={data.format}
                        onChange={e => setData('format', e.target.value)}
                        required={true}
                    >
                        <FormControlLabel value="xlsx   " control={<Radio color="primary" />} label="Excel" />
                        <FormControlLabel value="csv" control={<Radio color="primary" />} label="CSV" />
                        {
                            !!report.enable_html_table && <FormControlLabel value="html" control={<Radio color="primary" />} label="Show on screen" />
                        }
                    </RadioGroup>
                </FormControl>
            </Grid>

            <ButtonWrapper>
                <MuiButton type="submit" variant="contained" color="secondary" disabled={!formValid}>
                    {
                        !processing && data.format === "html" ? <Trans i18nKey="reporting.showTable">Show table</Trans> : <Trans i18nKey="reporting.download">Download</Trans>
                    }
                    {
                        processing && <CircularProgress style={{ height: 28, width: 28 }}/>
                    }
                </MuiButton>
            </ButtonWrapper>
            {
                errors && errors.email && <p>{ errors.email }</p>
            }
            {
                errors && errors.password && <p>{ errors.password }</p>
            }
                {
                    htmlTableData && (
                        <div className={"overline-x-scroll w-full"}>
                            <h3>
                                <Trans i18nKey="reports.content">
                                    Reporting Content
                                </Trans>
                            </h3>
                            <TableContainer>
                                <Table
                                    size="small"
                                    aria-label={
                                        <Trans i18nKey="queueDetail.aDenseTable">
                                            a dense table
                                        </Trans>
                                    }
                                >
                                    <TableHead>
                                        <TableRow>
                                            {
                                                htmlTableData.length > 0 && Object.keys(htmlTableData[0]).map((item, key) => <TableCell key={key}>{item}</TableCell>)
                                            }
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            htmlTableData
                                                .map((item, key) => <TableRow key={key}>
                                                    {
                                                        Object.values(item).map((item, key) => <TableCell key={key}>{item}</TableCell>)
                                                    }
                                                </TableRow>)
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
)
}
</Grid>
</form>
)
}

ReportForm.layout = page => <Layout children={page}/>
